import { createContext } from "react";

export const FollowUpListDispatchContext = createContext();
export const FollowUpListStateContext = createContext();
